<template>
    <div>
        <Header @show-contact="showContact" :active="5" :title="'关于我们'"></Header>
        <!-- 导航栏 -->
        <div class="banner">
            <img class="banner-pc" src="../assets/image/banner/banner_about.jpg"></img>
            <img class="banner-m" src="../assets/image/banner/banner_about_m.png"></img>
        </div>
        <h1 class="titles">关于我们</h1>
        <!-- 公司介绍 -->
        <div class="info" id="team">
            <img class="background" src="../assets/image/about/background.png">
            <div class="top">
                <img src="../assets/image/icon/icon_firms.png">
                <div>
                    <h1>杭州慧建智联科技有限公司 </h1>
                    <p>杭州慧建智联科技有限公司成立于2021年，总部位于杭州，同时设有两个研发中心和一个技术支持中心。<br>慧建智联致力于拓展现实+人工智能研发，结合智能传感器、物联网、空间智能、边缘计算等先进技术自主研发国产化工业级XR智能硬件产品及解决方案。凭借丰富的智能领域服务经验和技术积累，慧建智联自主研发的荟镜XR头显设备具有清晰度高、视野广阔、延时低、无眩光的视觉效果，致力于成为工业级XR领域全球领先的标杆产品。
                    </p>
                </div>
            </div>
        </div>
        <div class="info-m">
            <img src="../assets/image/icon/icon_firms_m.png" align="left">
            <h3 style="font-weight: 500;">杭州慧建智联科技有限公司 </h3>
            <p style="margin-top: 0.1rem;">杭州慧建智联科技有限公司成立于2021年，总部位于杭州，同时设有两个研发中心和一个技术支持中心。慧建智联致力于拓展现实+人工智能研发，结合智能传感器、物联网、空间智能、边缘计算等先进技术自主研发国产化工业级XR智能硬件产品及解决方案。凭借丰富的智能领域服务经验和技术积累，慧建智联自主研发的荟镜XR头显设备具有清晰度高、视野广阔、延时低、无眩光的视觉效果，致力于成为工业级XR领域全球领先的标杆产品。</p>
        </div>
        <!-- 团队介绍 -->
        <div class="team">
            <img class="icon" src="../assets/image/icon/icon_team.png">
            <div class="detail">
                <h1>团队介绍</h1>
                <div class="talent">
                    <div class="left">
                        <img src="../assets/image/icon/icon_title.png" class="icons">
                        <div class="txt">
                            <h2>人才介绍</h2>
                            <p>服务团队本科及以上人员占比100%，技术研发人员占比80%，其中技术团队硕博士人数占比63%。</p>
                        </div>
                    </div>
                    <img src="../assets/image/about/talent_m.png">
                </div>
                <div class="achievement">
                    <div class="left">
                        <img src="../assets/image/icon/icon_title.png" class="icons">
                        <div class="txt">
                            <h2>科研成果</h2>
                            <p>多项软件著作证书和专利证书</p>
                        </div>
                    </div>
                    <img src="../assets/image/about/achievement_m.jpg">
                </div>
            </div>
        </div>
        <div class="team-m">
            <h1 class="titles teams">能力支持</h1>
            <div class="content">
                <h2>研发能力</h2>
                <p style="text-align: left;">专业的研发团队，专注于虚拟现实VR软硬件技术的研发致力于开发出创新、前沿的VR产品和解决方案。</p>
                <img src="../assets/image/about/talent_m.png">
            </div>
            <div class="content">
                <h2 style="margin-bottom: 0.25rem;">专利和软著</h2>
                <img src="../assets/image/about/achievement_m.jpg">
            </div>
            <div style="display: flex;flex-direction: row;justify-content: center;margin-bottom: 0.4rem;">
                <h1 class="titles will">使命愿景</h1>
            </div>
            <div class="content">
                <h2 style="color: #5d74ac;margin-bottom: 0.1rem;font-weight: 500;">智联万物 慧建未来 </h2>
                <h2 style="color: #5d74ac;font-weight: 500;">Expanding Human Vision</h2>
                <img src="../assets/image/about/will.jpg" style="margin-top: 0.4rem;">
            </div>
            

        </div>
        <!-- 使命愿景 -->
        <div class="team" style="margin-bottom: 1rem;">
            <img class="icon" src="../assets/image/icon/icon_join.png">
            <div class="detail">
                <h1>使命愿景</h1>
                <div class="talent" style="margin-bottom: 0;">
                    <div class="left" style="display: flex;flex-direction: column;width: 4.7rem;margin: 0 0.6rem 0 -0.9rem">
                        <h1 style="color: #5d74ac;text-align: center;font-size: 0.27rem;">智联万物 慧建未来 </h1>
                        <h1 style="color: #5d74ac;text-align: center;font-size: 0.27rem;">Expanding Human Vision</h1>
                    </div>
                    <img src="../assets/image/about/will.jpg" style="width: 6.4rem;margin-top: -1.1rem;">
                </div>
            </div>
        </div>
        <!-- 结尾 -->
        <Footer></Footer>
        <Contact v-if="isContactVisible" @close="close"></Contact>
        <Email @show-contact="showContact"></Email>
    </div>
</template>
<script>
import Footer from '../components/Footer.vue'
import Header from '../components/Head.vue'
import Contact from '../components/Contact.vue'
import Email from '../components/Email.vue'
export default {
    data() {
        return {
            items: [
                { isExpanded: false },
                { isExpanded: false },
                // 其他项...
            ],
            titles:[
                {
                    name: 'Unity开发工程师',
                    content: [
                        '1. 使用unity引擎，负责公司虚拟现实系列产品的开发；',
                        '2. 深入理解客户业务需求，与项目部、美术等部门沟通，设计并实现仿真项目客户端逻辑；',
                        '3. 负责项目客户端的性能优化；',
                        '4. 负责研发过程中技术文档的编写及研发经验的积累和分享。'
                    ],
                    requirement: [
                        '1. 2年以上Unity开发经验，计算机科学、软件工程或相关专业本科及以上学历；',
                        '2. 具备完整的VR项目开发经验或游戏经验优先；',
                        '3. 熟练掌握C#语言,同时具有其他计算机语言项目使用经验者优先；',
                        '4. 有主流头盔、数据手套、CAVE等相关硬件的项目开发者优先；',
                        '5. 同时具备UE4开发经验者优先；',
                        '6. 沟通、学习能力强，有良好的团队合作精神，工作积极主动'
                    ],
                    contact: 'hr@huijianzhilian.com',
                    isExpanded: false
                },
                {
                    name: '售前支持工程师',
                    content: [
                        '1. 负责虚拟现实项目的客户业务调研、项目需求沟通、方案设计及招投标的技术文案撰写工作；',
                        '2. 负责展会现场及面向客户的公司产品Demo展示讲解，收集客户需求与意见；',
                        '3. 负责项目实施及验收过程中的成果与客户需求对比审核，为项目实施部门提供客户业务专业支撑；',
                        '4. 完成上级领导交办的其它事务。'
                    ],
                    requirement: [
                        '1. 3年以上工作经验，熟悉虚拟现实行业者，有1年以上虚拟现实项目的售前需求调研与方案设计经验者优先；',
                        '2. 了解虚拟现实相关技术，包括开发软件、仿真软件及相关硬件设备；',
                        '3. 具备创意能力，针对客户需求能够制定具有竞争力的策划方案；',
                        '4. 熟悉招标、投标的整个流程，有标书编写经验者优先；',
                        '5. 善于沟通，具有良好的表达能力，有轨道交通、电力、航空、航天、汽车等行业深入的业务知识优先；',
                        '6. 工作主动性强，能够承受一定的工作压力。'
                    ],
                    contact: 'hr@huijianzhilian.com',
                    isExpanded: false
                }
            ],
            up: '../assets/image/icon/icon_up.png',
            down: '../assets/image/icon/icon_down.png',
            isShow: false,
            isContactVisible: false
        }
    },
    components: {
        Footer,
        Header,
        Contact,
        Email
        
    },
    methods: {
        toggleDetails(index) {
            this.titles[index].isExpanded = !this.titles[index].isExpanded;
            this.items[index].isExpanded = !this.items[index].isExpanded;
        },
        openMenu() {
            this.isShow = !this.isShow;
        },
        showContact() {
            this.isContactVisible = true
        },
        close() {
            this.isContactVisible = false;
        }
    }
}
</script>
<style scoped>
    @import '../assets/css/aboutStyle.css';
</style>